import 'vuetify/styles'; // eslint-disable-line import/no-unresolved
import { createVuetify } from 'vuetify';

export default createVuetify();
